import { Fragment } from 'react';
import { BooleanInput, TextInput } from 'react-admin';
import { MENU_ENTRIES } from './menuEntries';

/**
 * Lets the editor rename or hide each mobile app menu entry.
 *
 * Leaving "Nombre" empty keeps the app default (shown as placeholder).
 * Hiding removes the entry from the main menu and the drawer; its screen stays
 * reachable from other screens (e.g. a speaker opened from a session).
 */
export const EditMenu = () => (
  <>
    <p style={{ marginTop: 0, color: 'rgba(0,0,0,0.6)' }}>
      Dejá el nombre vacío para usar el que trae la app. Ocultar saca la entrada
      del menú principal y del menú lateral.
    </p>
    {MENU_ENTRIES.map(entry => (
      <Fragment key={entry.configKey}>
        <TextInput
          fullWidth
          source={`menu.${entry.configKey}.label`}
          label={entry.defaultLabel}
          placeholder={entry.defaultLabel}
          helperText={`Vacío = "${entry.defaultLabel}"`}
        />
        <BooleanInput
          source={`menu.${entry.configKey}.hidden`}
          label="Ocultar"
        />
      </Fragment>
    ))}
  </>
);
